<div *ngIf="translateService.currentLang==='en'">
    <mat-dialog-content>
        <div class="mat-dialog">
            <h2 class="modal-title"><span>How to Submit Insurance Documents</span></h2>

            <div class="modal-body">
                <div>
                    <div class="insurance-content-wrapper">

                        <div class="row">
                            <div class="content">
                                <h3>Below are the options for submitting your insurance documents and what you need.</h3>
                        
                                <p>In order to update your account we need a copy of the full insurance policy outlining all coverages and requirements.
                                    For information on our requirements, please <a href="javascript:" (click)="closeModal()" target="_blank">see our FAQs about insurance</a>. The wallet-sized slips are not sufficient.</p>          
                            </div>
                        </div>

                        <div class="row">
                            <div class="icon">&nbsp;</div>
                            <div class="content">

                                <p><strong>If you have received an insurance tracking letter</strong></p>

                                <p><strong>You will need to provide the following:</strong></p>

                                <ol>
                                <li>A digital and legible copy of the full insurance policy outlining coverages and requirements ready to upload, not the wallet-sized slip.</li>
                                </ol>

                            </div>
                        </div>

                        <div class="row">
                            <h5 class="red">Sample Insurance Letter</h5>
                            <div class="letter-sample-zoom---" style="display:block;border:1px solid #333;border-radius:1rem;padding:.15rem .5rem;"><img alt="Image of sample insurance letter with reference number highlighted." src="./assets/images/pics/sample-insurance-cdlsi-en.png" class="img-responsive"></div>
                        </div>
                    
                        <div class="row">
                            <div class="icon"><img alt="Option one (1) Email (Envelope) Icon" src="./assets/images/icons/email_icon.v3.svg"></div>
                            <div class="content">
                    
                            <h4 class="red">By email</h4>
                    
                            <p><strong>If you have NOT received an insurance tracking letter</strong>, 
                                you can email your documents to <a href="mailto:insurance@cdlsi.com" (click)="onInsuranceEmailClick()">insurance&#64;cdlsi.com</a>
                    
                            </p><p><strong>You will need:</strong></p>
                    
                            <ol><li>A digital and legible copy of the full insurance policy outlining coverages and
                                requirements ready to attach, not the wallet-sized slip.
                                </li></ol>
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="icon"><img alt="Option two (2) Mail (Airplane) Icon" src="./assets/images/icons/post_icon.v3.svg"></div>
                            <div class="content">
                    
                                <h4 class="red">By mail</h4>
                        
                                <p><strong>You may submit your documents by mail to</strong>
                                    <br>Canadian Dealer Lease Services Inc.
                                    <br>PO Box 8138, Station “T”, Ottawa, ON  K1G 4K4
                                </p>
                                <p><strong>You will need:</strong></p>
                        
                                <ol>
                                    <li>A legible copy of the full insurance policy outlining coverages and requirements, not the wallet-sized slip.</li>
                                </ol>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>  
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" style="padding: 20px;">
        <button mat-button class="btn-close" (click)="closeModal()"> CLOSE </button>
    </mat-dialog-actions>
</div>

<div *ngIf="translateService.currentLang==='fr'">
    <mat-dialog-content>
        <div class="mat-dialog">
            <h2 class="modal-title"><span>Soumettre documents d'assurance</span></h2>

            <div class="modal-body">
                <div>
                    <div class="insurance-content-wrapper">

                        <div class="row">
                            <div class="content">
                                <h3>Pour soumettre vos documents et les informations requises, veuillez voir les trois options suivantes.</h3>
                        
                                <p>Afin de mettre à jour votre compte, nous avons besoin d'une copie de la police d'assurance au complet décrivant toutes les exigences et couvertures. Pour plus d'informations sur nos exigences, <a href="javascript:" (click)="closeModal()">veuillez consulter notre FAQ sur l'assurance</a>. La petite carte de format portefeuille n’est pas suffisante.</p>          
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="icon">&nbsp;</div>
                            <div class="content">

                                <h4 class="red">Avec lettre de suivi d’assurance</h4>
                                <p><strong>Si vous avez reçu une lettre de suivi d’assurance</strong>.</p>

                                <p><strong>Vous aurez besoin:</strong></p>
                                <ol><li>Une copie numérique et lisible de votre police d’assurance au complet (décrivant toutes les exigences et
                                    couvertures) prête à être téléchargée et non la petite carte de format portefeuille.</li>
                                </ol>

                            </div>
                        </div>

                        <div class="row">
                            <h5 class="red">Spécimen de lettre d’assurance</h5>
                            <div class="letter-sample-zoom---" style="display:block;border:1px solid #333;border-radius:1rem;padding:.15rem .5rem;"><img alt="Image d’exemples de lettres d’assurance avec le numéro de référence en surbrillance." class="img-responsive" src="./assets/images/pics/sample-insurance-cdlsi-fr.png"></div>
                        </div>
                    
                        <div class="row">
                            <div class="icon"><img alt="Premier option (1) courriel (enveloppe) icône" src="./assets/images/icons/email_icon.v3.svg"></div>
                            <div class="content">                  
                                <h4 class="red">Par courriel</h4>

                                <p><strong>Si vous n’avez PAS reçu une lettre de suivi d’assurance </strong>, vous pouvez envoyer vos documents par
                                  courriel à <a href="mailto:assurance@cdlsi.com" (click)="onAssuranceEmailClick()">assurance&#64;cdlsi.com</a>.
                        
                                </p><p><strong>Vous aurez besoin :</strong></p>
                        
                                <ol><li>Une copie numérique et lisible de votre police d’assurance au complet décrivant toutes les exigences
                                    et couvertures prête à être téléchargée et non la petite carte de format portefeuille.
                                  </li></ol>
                            </div>
                        </div>
        
                        <div class="row">
                            <div class="icon"><img alt="Option deux (2) par la poste (avion) icône" src="./assets/images/icons/post_icon.v3.svg"></div>
                            <div class="content">
                                <h4 class="red">Par la poste</h4>

                                <p><strong>Vous pouvez envoyer vos documents par la poste à</strong>
                                  <br>CP 8138, Station “T”
                                  <br>Ottawa, ON K1G 4K4
                                </p>
                                <p><strong>Vous aurez besoin :</strong></p>
                        
                                <ol>
                                  <li>Une copie lisible de votre police d’assurance au complet décrivant toutes les exigences et couvertures et non la petite carte de format portefeuille.</li>
                                </ol>                        
                            </div>
                        </div>
                    </div> 
                </div>
            </div>  
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" style="padding: 20px;">
        <button mat-button class="btn-close" (click)="closeModal()"> CLOSE </button>
    </mat-dialog-actions>
</div>

 